
import VoiceIntercom from './voiceIntercom';

export default VoiceIntercom